import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import InfoIcon from '@mui/icons-material/Info';

import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { BugReportStatus } from '../../../../shared/constants';
import { Paths } from '../../../../shared/paths';
import { IBugReport } from '../../../../types/interfaces/bug-report';
import { useStyles } from './BugReportItem.styles';

interface IBugReportItemProps {
  report: IBugReport;
}

export default function BugReportItem(props: IBugReportItemProps) {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { navigate } = useNavigationStack();
  const { report } = props;

  return (
    <Box
      className={classes.bugReportItemWrapper}
      onClick={() => navigate(Paths.bugReports.toId(report.id))}>
      <Box className={classes.bugReportItemInfo}>
        <Typography variant="text-md-sb">{report.title}</Typography>
        <Typography variant="text-md">{report.type.name}</Typography>
      </Box>
      {report.status === BugReportStatus.responded && <InfoIcon />}
    </Box>
  );
}
